// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".awsui_root_3gfu1_3yy3l_5:not(#\\9){position:absolute !important;top:-9999px !important;left:-9999px !important}\n", ""]);
// Exports
module.exports = exports;
